export const AclExtended = 'extended'
export const Cursor = 'cursor'
export const DocumentSearchMode = 'mode'
export const Filter = 'filter'
export const Limit = 'limit'
export const Page = 'page'
export const PerPage = 'perPage'
export const Sort = 'sort'
